__turbopack_context__.v({
  "content": "charterFlightsTextComponent-module-scss-module__CIcUYG__content",
  "text": "charterFlightsTextComponent-module-scss-module__CIcUYG__text",
  "title": "charterFlightsTextComponent-module-scss-module__CIcUYG__title",
});
